import { Grid } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

export const Loading = memo(() => {
    return (
        <Grid justifyContent='center'>
            <Grid maxWidth={944} width='100%' gap={32}>
                <Skeleton height={84} width={840} />

                <Grid gap={16}>
                    <Skeleton height={148} width={840} />

                    {new Array(6).fill(null).map((_, index) => (
                        <Skeleton height={52} width={840} key={index} />
                    ))}
                </Grid>

                <Skeleton height={200} width={840} />
            </Grid>
        </Grid>
    );
});

Loading.displayName = 'Loading';
